export const getPublishScript = (formLid: string): string => 
    `<div class="subscribe-form" data-lid="${formLid}"></div><script src="${FORM_SCRIPT}" async defer></script>`;
